import * as React from 'react';

import type { StepDirection } from './lib/use-step-direction.js';
import { cn } from './lib/utils.js';

export type DimeSlideTransitionProps = Readonly<{
  transitionKey: string;
  direction: StepDirection;
  className?: string;
  children: React.ReactNode;
}>;

export function DimeSlideTransition({
  transitionKey,
  direction,
  className,
  children,
}: DimeSlideTransitionProps) {
  return (
    <div
      key={transitionKey}
      data-slide-direction={direction === 0 ? undefined : direction > 0 ? 'forward' : 'backward'}
      className={cn(
        direction !== 0 && 'animate-in fade-in-0 duration-200 ease-out motion-reduce:animate-none',
        direction > 0 && 'slide-in-from-right-8',
        direction < 0 && 'slide-in-from-left-8',
        className,
      )}
    >
      {children}
    </div>
  );
}
